import { useCallback, useState } from 'react';

export function useBaseViewModel() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();

  const catchAction = useCallback(async (action: () => Promise<void>) => {
    try {
      setLoading(true);
      setError(undefined);
      await action();
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    catchAction,
    loading,
    setLoading,
    error,
    setError,
  };
}
